import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_CHECKBOX_UNCHECKED_SCHEMA = Object.freeze({
  CHECKBOX_IDENTIFIER: '',
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_CHECKBOX_UNCHECKED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_CHECKBOX_UNCHECKED_SCHEMA);

export class CheckboxUncheckedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.checkbox_unchecked;
  }

  get properties() {
    return this.toJS();
  }
}
